import { pinChat } from "@/apis/chat"
import { SharedSelection } from "@heroui/react"
import { useMutation } from "@tanstack/react-query"
import { last } from "lodash"
import { useParams } from "next/navigation"
import { useLayoutEffect, useState } from "react"

export const useList = ({ users, updateCb }) => {
  const params = useParams()

  const [values, setValues] = useState<SharedSelection>(new Set([params.session_id as string]));

  useLayoutEffect(() => {
    setValues(new Set([params.session_id as string]))
  }, [params.session_id])


  const pinChatMutation = useMutation({
    mutationFn: pinChat
  })

  const onPinned = (id) => {
    const chatInfo: any = users.find((item: any) => item?.id === id)

    if (chatInfo) {
      pinChatMutation.mutate({
        session_id: Number(chatInfo.id),
        is_pinned: Number(!chatInfo.pinned)
      },
        {
          onSuccess(data) {
            // pin 后处理本地数据
            updateCb((draft) => {
              let i = 0, j = 0, temp

              wrapper: for (i = 0; i < draft.pages.length; i++) {
                const page = draft.pages[i];
                for (j = 0; j < page.length; j++) {
                  if (String(page[j].id) === id) {
                    page[j].pinned = !page[j].pinned
                    temp = page[j]
                    break wrapper
                  }
                }
              }

              if (temp.pinned) {
                draft.pages[i].splice(j, 1)
                draft.pages[0].unshift(temp)

              } else {
                draft.pages[i].splice(j, 1)
                for (i = 0; i < draft.pages.length; i++) {
                  const page = draft.pages[i];
                  for (j = 0; j < page.length; j++) {
                    if (!page[j].pinned) {
                      page.splice(j, 0, temp)
                      return
                    }
                  }
                }
                const lastPage = last(draft.pages as []) as any
                lastPage.push(temp)
              }

            })

          }
        })
    }

  }

  return { onPinned, values }
}